import { render, staticRenderFns } from "./view-step.vue?vue&type=template&id=f781f4c4&scoped=true"
import script from "./view-step.vue?vue&type=script&lang=js"
export * from "./view-step.vue?vue&type=script&lang=js"
import style0 from "./view-step.vue?vue&type=style&index=0&id=f781f4c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f781f4c4",
  null
  
)

export default component.exports